export const formRowTypes = {
    text: 'text',
    number: 'number',
    select: 'select',
    checkbox: 'checkbox',
    fileUpload: 'fileupload',
    datePicker: 'datepicker'
}